import { KnowledgeItemPreviewItemModel } from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement, useMemo } from "react";
import { CardProps, HubItemStatistic } from "../common";
import { CardBase } from "./CardBase";
import { NumberFormatter } from "client/Hooks";
import { useHubStatisticsFormatter } from "client/Features/Hub/useHubStatisticsFormatter";
import { EMPTY_ARRAY, isNotNil } from "client/Misc/utils";

export type KnowledgeItemCardProps = CardProps<KnowledgeItemPreviewItemModel>;

export const KnowledgeItemCard = (props: KnowledgeItemCardProps): ReactElement => {
	const {
		item,
		size,
		onOpen,
		hasTopBarBackdrop,
		timezone
	} = props;

	const statisticsFormatter: NumberFormatter = useHubStatisticsFormatter();

	const statistics = useMemo(
		(): readonly HubItemStatistic[] => {
			return [{
				icon: "eye",
				text: statisticsFormatter(item.viewsCount),
				trackingId: "view-count"
			}];
		},
		[item.viewsCount, statisticsFormatter]
	);

	const categoryNames = useMemo(
		(): readonly string[] => {
			return isNotNil(item.category)
				? [
					item.category
						.name
				]
				: EMPTY_ARRAY;
		},
		[item.category]
	);

	return (
		<CardBase
			itemKind={HubItemKind.KnowledgeItem}
			id={item.id}
			title={item.title}
			media={item.media}
			startDate={item.publicationDate}
			statistics={statistics}
			categoryNames={categoryNames}
			size={size}
			onOpen={onOpen}
			hasTopBarBackdrop={hasTopBarBackdrop}
			timezone={timezone}
			isPinned={isNotNil(item.pinDate)}
			isNew={item.isNew}
		/>
	);
};
KnowledgeItemCard.displayName = "KnowledgeItemCard";
